import { useState, useEffect, useCallback, useRef } from 'react';
import { getNotifications } from '../services/api';

const POLL_INTERVAL_MS = 30_000;

export function useNotifications(enabled = true) {
  const [data, setData] = useState({ total: 0, waiting_room: 0, pending_today: 0, whatsapp_due: 0 });
  const [loading, setLoading] = useState(false);
  const timerRef = useRef(null);

  const fetch = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    try {
      const res = await getNotifications();
      setData(res.data);
    } catch {
      // silent — network errors don't break the UI
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return;
    fetch();
    timerRef.current = setInterval(fetch, POLL_INTERVAL_MS);
    return () => clearInterval(timerRef.current);
  }, [enabled, fetch]);

  return { ...data, loading, refresh: fetch };
}
